export default __webpack_public_path__ + "/680f69f3c2e6b90c1812a813edf67fd7.png";